import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableContainer } from '@mui/material';
import GenericEntityFlowEditStatesHead from './GenericEntityFlowEditStatesHead';
import GenericEntityFlowEditStatesBody from './GenericEntityFlowEditStatesBody';
import { get } from '@totalsoft/change-tracking-react';
import FlexBox from 'components/common/FlexBox';
import ErrorIcon from '@mui/icons-material/Error';
import { Typography } from '@totalsoft/rocket-ui';

const GenericEntityFlowEditStatesTable = ({ genericEntityFlowStatesLens, genericEntityBusinessStates, onDelete, validation }) => {
  const [t] = useTranslation();
  return (
    <>
      <TableContainer>
        <Table>
          <GenericEntityFlowEditStatesHead />
          <GenericEntityFlowEditStatesBody
            genericEntityFlowStatesLens={genericEntityFlowStatesLens}
            genericEntityBusinessStates={genericEntityBusinessStates}
            onDelete={onDelete}
            validation={validation}
          />
        </Table>
      </TableContainer>
      {(!genericEntityFlowStatesLens || (genericEntityFlowStatesLens |> get)?.length === 0) && (
        <FlexBox gap={0.5} alignItems='center' justifyContent='center' pt={2}>
          <ErrorIcon fontSize='small' />
          <Typography>{t('TableIsEmpty')}</Typography>
        </FlexBox>
      )}
    </>
  );
};

GenericEntityFlowEditStatesTable.propTypes = {
  genericEntityFlowStatesLens: PropTypes.object.isRequired,
  genericEntityBusinessStates: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default GenericEntityFlowEditStatesTable;
